import * as Cookies from "js-cookie";

import * as CryptoJS from "crypto-js";

export const initCarrinho = {
    usuarioCadastroId:0,
    dataCadastro: new Date(),
    statusVenda:0,
    clienteId:0,
    estabelecimentoId:0,
    avaliacaoId:0,
    qtdItensTotalCarrinho: 0,
    itens:[],
    totalizadorItens:{
      totalItens: 0,
      totalDescontos:0,
      TotalItensComDesconto:0
    }
};

const Encripta = (dados) => { 
    const cryptoInfo = CryptoJS.AES.encrypt(JSON.stringify(dados), process.env.REACT_APP_KEY);
    return cryptoInfo.toString(CryptoJS.format.Base64);
}
const Descripta = (dados) => { 
  return CryptoJS.AES.decrypt(dados.toString(), process.env.REACT_APP_KEY).toString(CryptoJS.enc.Utf8); 
}

export const setcarrinhoVendaCookie = (carrinhoVenda) => {
  let carrinho_item = Encripta(carrinhoVenda);
  localStorage.setItem('carrinhoVenda', carrinho_item);
};

export const getcarrinhoVendaCookie = () => {
  if(localStorage.getItem('carrinhoVenda') != null && localStorage.getItem('carrinhoVenda') != "null"){
    let carrinho_item = Descripta(localStorage.getItem('carrinhoVenda'));
    return JSON.parse(carrinho_item);  
  }
  else{ return null; }
};

export const setResultadoVendaCookie = (data) => {
  Cookies.remove("resultadoVendaCookie");
  Cookies.set("resultadoVendaCookie", data, { expires: 0.08 });
};

export const getResultadoVendaCookie = () => {
  const resultadoVendaCookie = Cookies.get("resultadoVendaCookie");
  if (resultadoVendaCookie === undefined) {
    return null;
  } else {
    return JSON.parse(resultadoVendaCookie);
  }
};
